import { UserIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';
import HtmlContentContainer from '@/components/html-content-container';
import type { CmsContactItem } from '@/lib/cms-contact-list';

export type ContentSalesTeamPageProps = {
  contactList: CmsContactItem[];
  descriptionHtml: string;
};

export default function ContentSalesTeamPage({ contactList, descriptionHtml }: ContentSalesTeamPageProps) {
  return (
    <>
      <HtmlContentContainer className='mt-8' html={descriptionHtml} />

      <div className='py-16 sm:py-24 lg:py-32'>
        <ul className='mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8 xl:max-w-none'>
          {contactList.map((person) => (
            <li key={person.name} className='flex flex-col gap-6 xl:flex-row'>
              <div className='h-32 w-32 rounded-full border border-neutral-300 shadow-md'>
                {person.photo ? (
                  <Image
                    alt={person.name}
                    className='h-full w-full rounded-full object-cover'
                    height={200}
                    src={person.photo}
                    width={200}
                  />
                ) : (
                  <div className='bg-surface-suspend inline-flex h-full w-full items-center justify-center rounded-full'>
                    <UserIcon aria-hidden='true' className=' text-content-suspend h-12 w-12' />
                  </div>
                )}
              </div>
              <div className='flex-1'>
                <h3 className='text-content-focus text-lg font-semibold leading-8 tracking-tight'>{person.name}</h3>
                {person.position && <p className='text-content text-base leading-7'>{person.position}</p>}
                {person.email && (
                  <p className='text-content hover:text-primary-focus text-base leading-7'>
                    <a href={`mailto:${person.email}`}>{person.email}</a>
                  </p>
                )}
                {person.phone && (
                  <p className='text-content hover:text-primary-focus text-base leading-7'>
                    <a href={`tel:${person.phone.replace(/\s+/, '')}`}>{person.phone}</a>
                  </p>
                )}
                {person.region && <p className='text-content mt-6 text-base leading-7'>{person.region}</p>}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
